var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-card",
    { attrs: { id: "stemdoer-card" } },
    [
      _c(
        "v-container",
        {
          staticClass: "p-0 m-0 h-100 w-100 stemdoer-card-container",
          attrs: { fluid: "", "data-cy": "stemdoer-card-container" },
          on: {
            click: () => {
              _vm.openStemdoerDetailModal(_vm.mutableStemdoer)
            },
          },
        },
        [
          _c(
            "v-row",
            { staticClass: "h-100 w-100", attrs: { "no-gutters": "" } },
            [
              _c(
                "v-col",
                {
                  staticClass: "d-flex flex-column p-3 h-100",
                  attrs: { cols: "auto", id: "StemdoerCardfirstColImg" },
                },
                [
                  _c(
                    "v-row",
                    {
                      staticClass: "d-flex justify-center flex-grow-0 px-3",
                      attrs: { "no-gutters": "" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: { position: "relative" },
                          attrs: { width: "90px" },
                        },
                        [
                          _vm.hasValidEnglishLevel
                            ? _c(
                                "div",
                                {
                                  staticStyle: {
                                    position: "absolute",
                                    bottom: "0.6em",
                                    right: "0.4em",
                                    "z-index": "2",
                                    transform: "scale(1.16)",
                                  },
                                  attrs: { color: "#f9f9f9" },
                                },
                                [
                                  _c(
                                    "span",
                                    { attrs: { slot: "badge" }, slot: "badge" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "d-flex justify-center",
                                          staticStyle: {
                                            border: "1px solid #dbdbe0",
                                            "border-radius": "50%",
                                            "background-color": "white",
                                            height: "32px",
                                            width: "32px",
                                            transform: "scale(0.8)",
                                          },
                                        },
                                        [
                                          _c("img", {
                                            staticStyle: {
                                              "border-radius": "50%",
                                              width: "20px",
                                            },
                                            attrs: {
                                              src: "/content/svgs/stemdoer-detail/english.svg",
                                              "data-cy": "english-level-badge",
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("SAvatarStemdoer", {
                            staticClass: "my-3",
                            staticStyle: { "z-index": "1" },
                            attrs: {
                              stemdoId: _vm.mutableStemdoer.stemdoId,
                              "data-cy": "stemdoer-avatar",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    {
                      staticClass: "flex-grow-0 mt-1",
                      attrs: { "no-gutters": "" },
                    },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "d-flex justify-center",
                          attrs: { cols: "12" },
                        },
                        [
                          !_vm.mutableStemdoer.availability.available &&
                          _vm.mutableStemdoer.availability.availableAt !==
                            null &&
                          !_vm.mutableStemdoer.canBeAddedToCart
                            ? _c(
                                "div",
                                {
                                  staticClass: "text-center available-label",
                                  attrs: {
                                    "data-cy": "stemdoer-availability-date",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "available-text p-1" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t(
                                              "explore.stemdoer-card.availability"
                                            )
                                          ) +
                                          "\n                " +
                                          _vm._s(
                                            _vm.$d(
                                              Date.parse(
                                                _vm.mutableStemdoer.availability
                                                  .availableAt
                                              ),
                                              "twoDigitWithoutYear"
                                            )
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : !_vm.mutableStemdoer.availability.available &&
                              _vm.mutableStemdoer.availability.availableAt ===
                                null
                            ? _c(
                                "div",
                                {
                                  staticClass: "text-center available-label",
                                  attrs: {
                                    "data-cy":
                                      "stemdoer-availability-indeterminate",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "available-text p-1" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t(
                                              "explore.stemdoer-card.indeterminate"
                                            )
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    {
                      staticClass: "flex-grow-0 mt-auto",
                      attrs: { "no-gutters": "" },
                    },
                    [
                      _vm.isLoaded
                        ? _c(
                            "v-col",
                            {
                              staticClass: "d-flex flex-row pl-1",
                              staticStyle: { position: "relative" },
                              attrs: { "data-cy": "stemdoer-certifications" },
                            },
                            _vm._l(
                              _vm.getCertification(),
                              function (cert, ind) {
                                return _vm.Certification.getCertificationImgUrlByName(
                                  cert.name
                                ) != "" && ind < 3
                                  ? _c(
                                      "div",
                                      {
                                        key: cert.id,
                                        staticClass: "pr-1",
                                        staticStyle: {
                                          width: "fit-content",
                                          position: "relative",
                                        },
                                      },
                                      [
                                        _c(
                                          "v-tooltip",
                                          {
                                            attrs: { top: "" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function ({ on, attrs }) {
                                                    return [
                                                      _c(
                                                        "v-img",
                                                        _vm._g(
                                                          _vm._b(
                                                            {
                                                              attrs: {
                                                                src: _vm.Certification.getCertificationImgUrlByName(
                                                                  cert.name
                                                                ),
                                                                width: "35px",
                                                                "data-cy":
                                                                  "stemdoer-certification-img",
                                                              },
                                                            },
                                                            "v-img",
                                                            attrs,
                                                            false
                                                          ),
                                                          on
                                                        )
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          },
                                          [
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(_vm._s(cert.name)),
                                            ]),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        ind === 2 &&
                                        _vm.getCertification().length > 3
                                          ? _c(
                                              "v-tooltip",
                                              {
                                                attrs: {
                                                  top: "",
                                                  "nudge-right": "20",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function ({
                                                        on,
                                                        attrs,
                                                      }) {
                                                        return [
                                                          _c(
                                                            "div",
                                                            _vm._g(
                                                              _vm._b(
                                                                {
                                                                  staticClass:
                                                                    "cert-plus-badge",
                                                                  attrs: {
                                                                    "data-cy":
                                                                      "stemdoer-certifications-more",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        $event.stopPropagation()
                                                                      },
                                                                  },
                                                                },
                                                                "div",
                                                                attrs,
                                                                false
                                                              ),
                                                              on
                                                            ),
                                                            [
                                                              _c("v-img", {
                                                                attrs: {
                                                                  src: "/content/svgs/plus.svg",
                                                                  width: "14px",
                                                                },
                                                              }),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              },
                                              [
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  _vm._l(
                                                    _vm
                                                      .getCertification()
                                                      .slice(3),
                                                    function (extra) {
                                                      return _c(
                                                        "div",
                                                        { key: extra.id },
                                                        [
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(
                                                                extra.name
                                                              ) +
                                                              "\n                  "
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              }
                            ),
                            0
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-col",
                {
                  staticClass: "d-flex flex-column p-3 h-100 w-100",
                  attrs: { id: "profile" },
                },
                [
                  _c(
                    "v-row",
                    { staticClass: "flex-grow-0", attrs: { "no-gutters": "" } },
                    [
                      _c(
                        "h5",
                        {
                          staticClass: "text-body-1 color-text-black",
                          attrs: { "data-cy": "stemdoer-name" },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.mutableStemdoer.name +
                                  " " +
                                  _vm.mutableStemdoer.surname.split("")[0]
                              ) +
                              ".\n          "
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    { staticClass: "flex-grow-0", attrs: { "no-gutters": "" } },
                    [
                      _c(
                        "h4",
                        {
                          staticClass: "text-body-1-bold color-text-black",
                          attrs: { "data-cy": "stemdoer-position" },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.mutableStemdoer.position) +
                              "\n          "
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.isLoaded
                    ? _c(
                        "v-row",
                        {
                          staticClass: "flex-grow-0",
                          attrs: {
                            "no-gutters": "",
                            "data-cy": "stemdoer-skills",
                          },
                        },
                        _vm._l(
                          _vm.mutableStemdoer.badgesSkills.slice(0, 5),
                          function (badge, index) {
                            return _c(
                              "v-chip",
                              {
                                key: index,
                                staticClass: "mr-1 my-1 chips",
                                attrs: {
                                  density: "compact",
                                  "data-cy": "stemdoer-skill-badge",
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(badge.technology) +
                                    "\n          "
                                ),
                              ]
                            )
                          }
                        ),
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    {
                      staticClass: "flex-grow-0 mt-auto pb-2 justify-end",
                      attrs: { "no-gutters": "" },
                    },
                    [
                      _c("v-col", { attrs: { cols: "auto" } }, [
                        _c("div", { staticClass: "mr-2" }),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        { attrs: { cols: "auto" } },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "stemdoerBtnAdd text-capitalize",
                              attrs: {
                                elevation: "0",
                                disabled: !_vm.mutableStemdoer.canBeAddedToCart,
                                "data-cy": "stemdoer-add-to-cart-btn",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.addToCart(_vm.mutableStemdoer)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t("explore.stemdoer-card.addBtn")
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }